<!-- <ion-content padding> -->
<div class="gbr-loginbackground"></div>
<div class="gbr-loginpage">
	<div class="gbr-login-header">
        <button  [routerLink]="['/p/home']" routerDirection="forward" type="button" class="btn btn-primary btn-circle" style="float: left; margin: 10px 0 0 10px;">
            <i class="fa fa-arrow-left"></i>
        </button>
		<img src="assets/img/Kelvin2.png">
	</div>
	<div class="gbr-login-body">
        
		<form (ngSubmit)="f.form.valid && login()" #f="ngForm">
	
				
			<div 
				*ngIf="error" 
				class="alert alert-danger">
				{{error}}
			</div>
			<div class="form-group row">
				<input
					type="string"
					class="form-control col-sm-12"
					name="username" 
					[(ngModel)]="model.username" 
					placeholder="Gebruikersnaam" 
					required
				/>
			</div>
			<div class="form-group row">
				<input 
					type="password" 
					class="form-control col-sm-12"
					[ngClass]="{ 'is-invalid': f.submitted && !model.password }"
					name="password" 
					[(ngModel)]="model.password" 
					placeholder="Wachtwoord" 
					required
				/>
				<!-- <input 
					type="password" 
					class="form-control col-sm-12"
					[ngClass]="{ 'is-invalid': f.submitted && !password.valid }"
					name="password" 
					[(ngModel)]="model.password" 
					#password="ngModel" 
					placeholder="Password" 
					required
					> -->
			</div>
			<div class="form-group row">
				<button 
					[disabled]="loading" 
					type="submit" 
					class="btn btn-primary col-sm-12">
					Login
				</button>
			</div>
		</form>
	</div>
</div>
<!-- </ion-content> -->
